import { render, staticRenderFns } from "./BusinessMemberPrescriptionNotes.vue?vue&type=template&id=18383274"
import script from "./BusinessMemberPrescriptionNotes.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPrescriptionNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports